import gql from 'graphql-tag';

export const deliveryPackageToUnity = gql`
  mutation deliveryPackageToUnity($deliveryUuid: String!) {
    deliveryPackageToUnity(deliveryUuid: $deliveryUuid)
  }
`;

export const openBoxDrawer = gql`
  mutation openBoxDrawer(
    $uuid: String!
    $phone: String
    $unityId: Int
    $postalWorkerRegistration: String
    $latitude: Float
    $longitude: Float
    $locationAccuracy: Float
    $locationStatus: String
  ) {
    openBoxDrawer(
      uuid: $uuid
      phone: $phone
      unityId: $unityId
      postalWorkerRegistration: $postalWorkerRegistration
      latitude: $latitude
      longitude: $longitude
      locationAccuracy: $locationAccuracy
      locationStatus: $locationStatus
    )
  }
`;

export const cancelDelivery = gql`
  mutation cancelDelivery($deliveryUuid: String!) {
    cancelDelivery(deliveryUuid: $deliveryUuid)
  }
`;

export const authDeliveryCorreiosWorker = gql`
  mutation authDeliveryCorreiosWorker($authCredentials: AuthCredentials!) {
    authDeliveryCorreiosWorker(authCredentials: $authCredentials)
  }
`;
